import { ReactElement } from 'react';

interface SwitchProps {
  checked: boolean;
  onChange: (event: any, value: boolean) => void;
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
}

export default function Switch({
  checked,
  onChange,
  disabled = false,
  className = '',
  'aria-label': ariaLabel,
}: SwitchProps): ReactElement {
  const handleClick = () => {
    if (!disabled) {
      onChange({}, !checked);
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={handleClick}
      className={`
        cr-focus:cr-outline-none cr-focus:cr-ring-2 cr-focus:cr-ring-cirrusBlue-400 cr-focus:cr-ring-offset-2 
        cr-relative cr-inline-flex cr-h-6 
        cr-w-11 cr-flex-shrink-0 cr-cursor-pointer cr-rounded-full cr-border-2
        cr-border-transparent cr-transition-colors cr-duration-200 cr-ease-in-out
        ${checked ? 'cr-bg-cirrusBlue-100' : 'cr-bg-gray-200'}
        ${disabled ? 'cr-cursor-not-allowed cr-opacity-50' : 'hover:cr-bg-cirrusBlue-200'}
        ${className}
      `}
    >
      <span
        className={`
          cr-pointer-events-none cr-inline-block cr-h-5 cr-w-5 cr-transform cr-rounded-full 
          cr-bg-white cr-shadow cr-ring-0 cr-transition cr-duration-200 cr-ease-in-out
          ${checked ? 'cr-translate-x-5' : 'cr-translate-x-0'}
        `}
      />
    </button>
  );
}
